module.exports = __webpack_public_path__ + "img/logo-vwn.181684f4.png";